<template>
  <div>
    <div class="analytics-header-sticky flex rounded-t bg-slate-100">
      <div class="analytics-first-col-sticky pl-6 flex bg-slate-100">
        <div
          class="flex border-t border-l border-r border-slate-400 rounded-tl"
        >
          <div
            class="w-60 px-4 py-3 flex items-center flex-shrink-0 bg-slate-200 rounded-tl"
          >
            <BlTextSubtitle3 text="Client name" class="text-slate-700" />
          </div>
        </div>
      </div>
      <div
        v-for="(header, idx) in headers"
        :key="`header-${idx}`"
        class="w-40 px-4 py-3 flex items-center flex-shrink-0 bg-slate-200 border-t border-slate-400"
        :title="header"
      >
        <BlTextSubtitle3 :text="header" class="text-slate-700 truncate" />
      </div>
      <div
        v-for="(header, idx) in subHeaders"
        :key="`subheader-${idx}`"
        class="bg-slate-200 border-t border-l border-slate-400"
        :class="{ 'border-r': idx + 1 === subHeaders.length }"
      >
        <div
          class="px-4 py-3 flex justify-center flex-shrink-0"
          :title="header.label"
        >
          <BlTextSubtitle3
            :text="header.label"
            class="text-slate-700 truncate"
          />
        </div>
        <div class="flex">
          <div
            v-for="(sub, idx2) in header.subs"
            :key="`sub-${idx2}`"
            class="w-25 px-4 py-3 flex flex-shrink-0 border-t border-slate-400"
            :title="sub"
          >
            <BlTextSubtitle3 :text="sub" class="text-slate-700 truncate" />
          </div>
        </div>
      </div>
      <div
        class="w-40 px-4 py-3 flex items-center flex-shrink-0 bg-slate-200 border-t border-slate-400"
        title="Client tags"
      >
        <BlTextSubtitle3 text="Client tags" class="text-slate-700 truncate" />
      </div>
      <div class="analytics-last-col-sticky pr-6 flex bg-slate-100 flex-grow">
        <div
          class="w-32 px-4 py-3 flex flex-shrink-0 flex-grow bg-slate-200 border-t border-r border-slate-400 rounded-tr"
        ></div>
      </div>
    </div>
    <div v-if="!tableData.length" class="h-64 grid bg-slate-100">
      <div
        class="sticky h-64 grid flex-col place-content-center text-center bg-pure-white border-l border-r border-b border-slate-400 rounded-b"
        :style="{
          left: 'calc(15rem + 1.5rem)',
          width: 'calc(100vw - 15rem - 3rem - 0.5rem)'
        }"
      >
        <BlTextBody2 :text="emptyState.title" class="px-4 font-semibold" />
        <BlTextBody2
          v-for="(text, idx) in emptyState.desc"
          :key="idx"
          :text="text"
          class="px-4"
        />
      </div>
    </div>
    <RowAppointmentClient
      v-else
      v-for="(n, idx) in tableData"
      :key="n.id"
      :item="n"
      :isLast="idx + 1 === tableData.length"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

import RowAppointmentClient from "./RowAppointmentClient.vue";

import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";

export default {
  name: "TableAppointmentClient",
  components: {
    RowAppointmentClient,
    BlTextSubtitle3,
    BlTextBody2
  },
  props: {
    tableData: { type: Array, default: () => [] }
  },
  data() {
    return {
      emptyState: {
        title: "No appointments recorded yet",
        desc: [
          "It looks like you've selected a future date range. Since no appointments have been completed or cancelled yet, there's no data to display.",
          "Try selecting a date range that includes past or current dates to view your appointment history."
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter"]),
    enableBranch() {
      return this.currentCenter.enable_branch;
    },
    headers() {
      return [
        ...(this.enableBranch ? ["Client branches"] : []),
        "Therapist on duty"
      ];
    },
    subHeaders() {
      const headers = ["By session count", "By total hours"];
      const subs = ["Scheduled", "Completed", "Cancelled"];
      return headers.map(i => ({ label: i, subs }));
    }
  },
  methods: {
    displayDate(date, format = "DD/MM/YYYY") {
      if (!date) return "-";
      return moment(date).format(format);
    }
  }
};
</script>

<style scoped lang="scss">
.analytics-header-sticky {
  position: sticky;
  top: 9rem;
  left: 15rem;
  z-index: 2;
}
.analytics-first-col-sticky {
  position: sticky;
  left: 15rem;
  z-index: 1;
}
.analytics-last-col-sticky {
  position: sticky;
  right: 0rem;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/analytics/table/TableAppointmentClient.vue